<template>
  <div>
    <v-text-field
      v-model="value"
      ref="autocomplete"
      :color="$finColors.primaryDark"
      :loading="isLoading"
      placeholder="Bitte Namen oder ISIN eingeben"
      :prepend-inner-icon="searchIcon"
      hide-details
      clearable
      outlined
      @blur="blurAutocomplete"
      @focus="focusAutocomplete"
    >
    </v-text-field>
  </div>
</template>

<script>
import DataFetcher from "@/components/common/DataLoader/DataFetcher"
import {debounce} from 'debounce'

export default {
  name: "FinSearch",
  props: {
    /** The value object */
    /** Array of strings or objects, Promise or Function (that returns a Promise or array), used for the search */
    resolver: {},
    /** Set if the search keyword can be cleared */
    clearable: {
      type: Boolean,
      default: false
    },
    /** The placeholder to show if autocomplete doesn't have the focus */
    placeholder: {
      type: String
    },
    /** Customize the inner search icon */
    searchIcon: {
      type: String,
      default: 'icon-search'
    },
  },
  data() {
    return {
      search: null,
      isLoading: false,
      entries: [],
      prevSearch: null,
      prevEntries: [],
      /**
       * Is used to cancel pending promises
       */
      lastPromise: null,
      emptyOrLastResult: false,
      value: null
    }
  },
  methods: {
     _loading() {
      this.isLoading = true
      const promise = DataFetcher.fetchData(this.resolver, {searchKeyword: this.value, from: this.entries.length})
      this.lastPromise = promise
      // Cancels promise if newer promise is faster than older promise
      return new Promise((resolve, reject) => {
        promise.then(result => {
          // Check if promise is the latest send
          if (promise === this.lastPromise) {
            this.lastPromise = null
            this.entries = this.entries.concat(result)
            this.emptyOrLastResult = result.length === 0
            this.$emit('searchResult', this.entries)
          }
        }).finally(() => {
          this.isLoading = false
        })
      })
    },
    _searchByKeyword() {
      this.emptyOrLastResult = false
      this.entries = []
      this._loading()
    },
    blurAutocomplete() {
      if (this.value && this.entries && this.entries.length > 0) {
        this.prevEntries = this.entries
        this.prevSearch = this.value
      }
    },
    focus() {
      this.$refs.autocomplete.focus()
    },
    focusAutocomplete() {
      if (this.prevSearch && this.prevSearch.length > 0) {
        this.value = this.prevSearch
        this.entries = this.prevEntries
      }
    },
  },
  watch: {
    value: debounce(async function (searchKeyword) {
      if (searchKeyword === undefined || searchKeyword === null || searchKeyword === '') {
        this.prevEntries = null
        this.prevSearch = null
        this.entries = []
        this.$emit('searchResult', this.entries)
        return
      }

      // skip if no searchKeyword is set
      if (!searchKeyword) {
        this.entries = []
        return
      }

      // skip if the previous search result can be used
      if (searchKeyword === this.prevSearch) {
        return
      }
      await this._searchByKeyword()
    }, 350),
  },
}
</script>

<style scoped>
::v-deep .icon-search.theme--dark {
  color: #fff !important;
}

::v-deep fieldset {
  border-color: #fff !important;
}

::v-deep .mdi-menu-down.theme--dark {
  color: #fff !important;
}
</style>
